function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import { mediaIcons } from '@bbc/psammead-assets/svgs';
import { GEL_SPACING, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { C_EBON, C_KINGFISHER, C_METAL, C_POSTBOX, C_SHADOW, C_WHITE } from '@bbc/psammead-styles/colours';
import { getSansBold, getSansRegular, getSerifMedium } from '@bbc/psammead-styles/font-styles';
import { getBrevier, getMinion, getPica } from '@bbc/gel-foundations/typography';
import { Link } from '@bbc/psammead-story-promo';
import { oneOf, shape, string, number } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import VisuallyHiddenText from '@bbc/psammead-visually-hidden-text';
import LiveLabel from '@bbc/psammead-live-label';
import { formatUnixTimestamp, formatDuration } from '@bbc/psammead-timestamp-container/utilities';
import detokenise from '@bbc/psammead-detokeniser';
import durationDictionary from '../utilities';
var TitleWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TitleWrapper",
  componentId: "sc-6oo8lp-0"
})(["color:", ";padding:", " 0;display:inline-block;width:100%;", ";", ";"], function (_ref) {
  var titleColor = _ref.titleColor;
  return titleColor;
}, GEL_SPACING, function (_ref2) {
  var service = _ref2.service;
  return service && getSansRegular(service);
}, function (_ref3) {
  var script = _ref3.script;
  return script && getPica(script);
});
var StyledLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "StyledLink",
  componentId: "sc-6oo8lp-1"
})(["&:hover ", "{text-decoration:underline;}&:focus ", "{text-decoration:underline;}"], TitleWrapper, TitleWrapper);
var CardWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CardWrapper",
  componentId: "sc-6oo8lp-2"
})(["padding-top:", ";background-color:", ";display:flex;flex-direction:column;outline:0.0625rem solid transparent;height:100%;"], GEL_SPACING, C_WHITE);
var TextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextWrapper",
  componentId: "sc-6oo8lp-3"
})(["padding:0 ", ";flex-grow:1;"], GEL_SPACING);
var StyledH3 = /*#__PURE__*/styled.h3.withConfig({
  displayName: "StyledH3",
  componentId: "sc-6oo8lp-4"
})(["", ";", ";color:", ";margin:0;"], function (_ref4) {
  var service = _ref4.service;
  return service && getSerifMedium(service);
}, function (_ref5) {
  var script = _ref5.script;
  return script && getPica(script);
}, function (_ref6) {
  var headerTextColor = _ref6.headerTextColor;
  return headerTextColor;
});
var NextLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "NextLabel",
  componentId: "sc-6oo8lp-5"
})(["", ";", ";color:", ";display:inline-block;", ""], function (_ref7) {
  var service = _ref7.service;
  return service && getSansBold(service);
}, function (_ref8) {
  var script = _ref8.script;
  return script && getPica(script);
}, C_KINGFISHER, function (_ref9) {
  var dir = _ref9.dir;
  return dir === 'rtl' ? "margin-left: ".concat(GEL_SPACING, ";") : "margin-right: ".concat(GEL_SPACING, ";");
});
var SummaryWrapper = /*#__PURE__*/styled.p.withConfig({
  displayName: "SummaryWrapper",
  componentId: "sc-6oo8lp-6"
})(["", ";", ";color:", ";padding-bottom:", ";margin:0;"], function (_ref10) {
  var service = _ref10.service;
  return service && getSansRegular(service);
}, function (_ref11) {
  var script = _ref11.script;
  return script && getBrevier(script);
}, C_METAL, GEL_SPACING_DBL);
var ButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ButtonWrapper",
  componentId: "sc-6oo8lp-7"
})(["", ";", ";padding:", ";background-color:", ";outline:0.0625rem solid transparent;color:", ";@media screen and (-ms-high-contrast:active){background-color:transparent;outline:none;}"], function (_ref12) {
  var service = _ref12.service;
  return service && getSansRegular(service);
}, function (_ref13) {
  var script = _ref13.script;
  return script && getMinion(script);
}, GEL_SPACING, function (_ref14) {
  var backgroundColor = _ref14.backgroundColor;
  return backgroundColor;
}, function (_ref15) {
  var durationColor = _ref15.durationColor;
  return durationColor;
});
var IconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-6oo8lp-8"
})(["> svg{color:", ";fill:currentColor;width:1.0625rem;height:0.75rem;margin:0;}"], function (_ref16) {
  var durationColor = _ref16.durationColor;
  return durationColor;
});
var DurationWrapper = /*#__PURE__*/styled.time.withConfig({
  displayName: "DurationWrapper",
  componentId: "sc-6oo8lp-9"
})(["", ""], function (_ref17) {
  var dir = _ref17.dir;
  return dir === 'ltr' ? "padding-left: ".concat(GEL_SPACING, ";") : "padding-right: ".concat(GEL_SPACING, ";");
});
var DurationTextWrapper = /*#__PURE__*/styled.span.attrs({
  'aria-hidden': 'true'
}).withConfig({
  displayName: "DurationTextWrapper",
  componentId: "sc-6oo8lp-10"
})([""]);
var programStateConfig = {
  live: {
    backgroundColor: C_POSTBOX,
    headerTextColor: C_EBON,
    titleColor: C_SHADOW,
    durationColor: C_WHITE
  },
  next: {
    backgroundColor: C_WHITE,
    headerTextColor: C_METAL,
    titleColor: C_METAL,
    durationColor: C_KINGFISHER
  },
  onDemand: {
    backgroundColor: C_EBON,
    headerTextColor: C_EBON,
    titleColor: C_SHADOW,
    durationColor: C_WHITE
  }
};
var HeadingContentWrapper = /*#__PURE__*/styled.span.attrs({
  role: 'text'
}).withConfig({
  displayName: "HeadingContentWrapper",
  componentId: "sc-6oo8lp-11"
})([""]);

var renderHeaderContent = function renderHeaderContent(_ref18) {
  var state = _ref18.state,
      link = _ref18.link,
      nextLabel = _ref18.nextLabel,
      liveLabel = _ref18.liveLabel,
      brandTitle = _ref18.brandTitle,
      service = _ref18.service,
      script = _ref18.script,
      startTime = _ref18.startTime,
      timezone = _ref18.timezone,
      locale = _ref18.locale,
      dir = _ref18.dir;
  var isLive = state === 'live';
  var isNext = state === 'next';
  var liveLabelIsEnglish = liveLabel === 'LIVE';
  var formattedStartTime = formatUnixTimestamp({
    timestamp: startTime,
    format: 'HH:mm',
    timezone: timezone,
    locale: locale,
    isRelative: false
  });
  var episodeTitle = formatUnixTimestamp({
    timestamp: startTime,
    format: 'LL',
    timezone: timezone,
    locale: locale,
    isRelative: false
  });
  var content = /*#__PURE__*/React.createElement(HeadingContentWrapper, null, isLive && /*#__PURE__*/React.createElement(LiveLabel, {
    service: service,
    dir: dir,
    liveText: liveLabel,
    ariaHidden: liveLabelIsEnglish,
    offScreenText: liveLabelIsEnglish ? 'Live' : null
  }), isNext && /*#__PURE__*/React.createElement(NextLabel, {
    service: service,
    script: script,
    dir: dir
  }, "".concat(nextLabel, " ")), brandTitle, /*#__PURE__*/React.createElement(VisuallyHiddenText, null, ", ", formattedStartTime, ", "), /*#__PURE__*/React.createElement(TitleWrapper, _extends({
    service: service,
    script: script
  }, programStateConfig[state]), episodeTitle));
  return state === 'next' ? content : /*#__PURE__*/React.createElement(StyledLink, {
    href: link
  }, content);
};

var ProgramCard = function ProgramCard(_ref19) {
  var dir = _ref19.dir,
      service = _ref19.service,
      script = _ref19.script,
      brandTitle = _ref19.brandTitle,
      summary = _ref19.summary,
      duration = _ref19.duration,
      durationLabel = _ref19.durationLabel,
      startTime = _ref19.startTime,
      state = _ref19.state,
      nextLabel = _ref19.nextLabel,
      liveLabel = _ref19.liveLabel,
      link = _ref19.link,
      timezone = _ref19.timezone,
      locale = _ref19.locale;
  return /*#__PURE__*/React.createElement(CardWrapper, null, /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(StyledH3, _extends({
    service: service,
    script: script
  }, programStateConfig[state]), renderHeaderContent({
    state: state,
    link: link,
    nextLabel: nextLabel,
    liveLabel: liveLabel,
    brandTitle: brandTitle,
    service: service,
    script: script,
    startTime: startTime,
    timezone: timezone,
    locale: locale,
    dir: dir
  })), summary && /*#__PURE__*/React.createElement(SummaryWrapper, {
    service: service,
    script: script
  }, summary)), /*#__PURE__*/React.createElement(ButtonWrapper, _extends({
    service: service,
    script: script
  }, programStateConfig[state]), /*#__PURE__*/React.createElement(IconWrapper, programStateConfig[state], mediaIcons.audio), /*#__PURE__*/React.createElement(DurationWrapper, {
    dir: dir,
    dateTime: duration
  }, /*#__PURE__*/React.createElement(VisuallyHiddenText, null, " ".concat(detokenise(durationLabel, durationDictionary({
    duration: duration,
    locale: locale
  })), " ")), /*#__PURE__*/React.createElement(DurationTextWrapper, null, formatDuration({
    duration: duration,
    locale: locale
  })))));
};

var programCardPropTypes = {
  service: string.isRequired,
  script: shape(scriptPropType).isRequired,
  brandTitle: string.isRequired,
  link: string.isRequired,
  state: string.isRequired,
  nextLabel: string.isRequired,
  liveLabel: string.isRequired,
  startTime: number.isRequired,
  timezone: string,
  locale: string
};
var programCardDefaultPropTypes = {
  timezone: 'Europe/London',
  locale: 'en-gb'
};
renderHeaderContent.propTypes = _objectSpread({}, programCardPropTypes);
renderHeaderContent.defaultProps = _objectSpread({}, programCardDefaultPropTypes);
ProgramCard.propTypes = _objectSpread({
  dir: oneOf(['rtl', 'ltr']),
  duration: string.isRequired,
  durationLabel: string.isRequired,
  summary: string
}, programCardPropTypes);
ProgramCard.defaultProps = _objectSpread({
  dir: 'ltr',
  summary: null
}, programCardDefaultPropTypes);
export default ProgramCard;